// Carry the explicitly selected UI tenant; authorization remains server-side.
export function appendProductionInstanceScope(input, { pathname, apiBase } = {}) {
  if (typeof input !== 'string' || !apiBase) return input;
  const match = String(pathname || '').match(/^\/instance\/([^/]+)(?:\/|$)/i);
  if (!match) return input;
  try {
    const base = new URL(apiBase, window.location.origin);
    const url = new URL(input, window.location.origin);
    const prefix = `${base.pathname.replace(/\/$/, '')}/production`;
    if (url.origin !== base.origin || !(url.pathname === prefix || url.pathname.startsWith(`${prefix}/`))) return input;
    const selected = decodeURIComponent(match[1]);
    const suppliedSlugs = url.searchParams.getAll('instanceUniqueId');
    if (suppliedSlugs.length) {
      // Collapse duplicate canonical keys while retaining every distinct value
      // through the supported alias used by the server's contradiction check.
      const canonical = suppliedSlugs[0];
      url.searchParams.set('instanceUniqueId', canonical);
      const aliases = new Set(url.searchParams.getAll('instanceSlug'));
      for (const slug of [...suppliedSlugs.slice(1), selected]) {
        if (slug !== canonical && !aliases.has(slug)) {
          url.searchParams.append('instanceSlug', slug);
          aliases.add(slug);
        }
      }
    } else {
      url.searchParams.append('instanceUniqueId', selected);
    }
    return url.toString();
  } catch {
    return input;
  }
}
